import { createContext } from 'react'

import { BadgeEarnedPopupContextType } from './BadgeEarnedPopupContext.types'

export const BadgeEarnedPopupContext = createContext<BadgeEarnedPopupContextType | undefined>(undefined)
